import React from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const TodoKeep = ({ id, title, description }) => {
  return (
    <Card>
      <h4 className="m-b">{title}</h4>
      <p className="m-b">{description}</p>
      <DelIcon>
        <span className="icon-e">
          <NavLink to={`/update/${id}`}>
            <EditIcon />
          </NavLink>
        </span>
        <span className="icon-e">
          <NavLink to={`/delete/${id}`}>
            <DeleteIcon />
          </NavLink>
        </span>
      </DelIcon>
    </Card>
  );
};

export default TodoKeep;

const Card = styled.div`
  box-shadow: 3px 3px 10px 3px rgb(238, 234, 234);
  width: 380px;
  padding: 30px 20px;
  background-color: white;
  border-radius: 10px;
  margin: 20px;

  & > .m-b {
    margin-bottom: 10px;
  }
  &:hover {
    box-shadow: inset 3px 3px 10px 3px rgb(238, 234, 234);
    transition: all 0.2s;
  }
`;

const DelIcon = styled.div`
  text-align: right;
  /* border: 1px solid; */
  display: flex;
  align-items: center;
  justify-content: right;
  & > .icon-e {
    box-shadow: 3px 3px 10px 3px rgb(221, 214, 214);
    cursor: pointer;
    text-align: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      color: rgb(255, 32, 32);
    }
    & > a {
      text-decoration: none;
      color: black;
    }
  }
`;
